export default function HowToBuy() {
  return (
    <section className="tw-bg-white tw-pt-[88px] tw-pb-10 tw-text-center">
      <div className="tw-max-w-[1120px] tw-mx-auto tw-px-6 xl:tw-px-0 tw-flex tw-flex-col tw-items-center tw-gap-12">
        <h2 className="tw-text-3xl md:tw-text-[40px] tw-leading-[normal] tw-font-semibold tw-tracking-[-0.01em] tw-text-[#111]">
          How to buy the EUME Accidental Care Plan?
        </h2>

        <p className="tw-max-w-[760px] tw-text-base md:tw-text-[17px] tw-leading-7 tw-text-[#4B5563]">
          You can add EUME Accidental Care Plan to your cart when you buy a
          Eume products on{" "}
          <a
            href="https://eumeworld.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="tw-font-semibold tw-text-[#4B5563] tw-underline hover:tw-text-[#f1b324] tw-transition-colors"
          >
            eumeworld.com
          </a>
          . Product owners who are eligible for a EUME Accidental Care Plan can
          find an offer in the Eume’s website.
        </p>
      </div>
    </section>
  );
}
